import axios from "./axios"; // Import the centralized Axios instance
import prm from "./prm";

const state = {
  sales_orders: [],
  cash_register_report: [],
};

const getters = {
  allSalesOrders: (state) => state.sales_orders,
  allCashRegisterReport: (state) => state.cash_register_report,
};

const actions = {
  async fetchAllSalesOrders({ commit }, params = {}) {
    try {
      const response = await axios.get("/reports/sales-order/all", {
        params: prm(params),
      });
      commit("setSalesOrders", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch sales_orders:", error);
      if (error.status == 404) {
        commit("setSalesOrders", { data: [] });
        return { data: [] };
      }
    }
  },
  async fetchDailySalesOrders({ commit }, params = {}) {
    try {
      const response = await axios.get("/reports/sales-order/daily", {
        params: prm(params),
      });
      commit("setSalesOrders", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch sales_orders:", error);
      if (error.status == 404) {
        commit("setSalesOrders", { data: [] });
        return { data: [] };
      }
    }
  },
  async fetchCashRegisterReport({ commit }, params = {}) {
    try {
      commit("resetCashRegisterReport");
      const response = await axios.get(`/reports/cash-register/${params.cash_register_id}`);
      commit("setCashRegisterReport", response.data);
      return response.data;
    } catch (error) {
      console.error("Failed to fetch cash_register:", error);
      if (error.status == 404) {
        commit("resetCashRegisterReport");
        return { data: [] };
      }
    }
  },
};

const mutations = {
  setSalesOrders(state, sales_orders) {
    state.sales_orders = sales_orders.data; // Ensure this matches your API's response structure
  },
  setCashRegisterReport(state, cash_register_report) {
    state.cash_register_report = cash_register_report.data; // Ensure this matches your API's response structure
  },
  addSalesOrder(state, sales_order) {
    state.sales_orders.push(sales_order);
  },
  updateSalesOrder(state, updatedSalesOrder) {
    const index = state.sales_orders.findIndex(
      (sales_order) => sales_order.id === updatedSalesOrder.id
    );
    if (index !== -1) {
      state.sales_orders.splice(index, 1, updatedSalesOrder);
    }
  },
  closeSalesOrder(state, closedSalesOrder) {
    const index = state.sales_orders.findIndex(
      (sales_order) => sales_order.id === closedSalesOrder.id
    );
    if (index !== -1) {
      state.sales_orders.splice(index, 1, closedSalesOrder);
    }
  },
  removeSalesOrder(state, id) {
    state.sales_orders = state.sales_orders.filter(
      (sales_order) => sales_order.id !== id
    );
  },
  resetCashRegisterReport(state) {
    state.cash_register_report = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
